canvas[data-v-f91502f8]{margin-left:auto;margin-right:auto;padding:10px;display:block}img[data-v-f91502f8]{max-width:100%;max-height:60vh;margin-left:auto;margin-right:auto;padding:10px;display:block}
